import type { AppRouter } from '@trpc-endpoints/trpc-public/router'
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client'
import { trpcFetcher } from 'reusable/fetching/trpc-fetcher'
import variables from 'variables/variables'
import superjson from 'superjson'
import { errorTransformerLink } from 'api/trpc/trpc-client'
import { readInPersonSession } from 'features/meetings/meeting/in-person-recording/InPersonSessionStorage'

const createPublicClient = (silent = false) => {
   return createTRPCProxyClient<AppRouter>({
      transformer: superjson,
      links: [
         errorTransformerLink,
         httpBatchLink({
            url: `${variables.apiUrl}/trpc-public`,
            maxURLLength: 2048,
            async fetch(input: RequestInfo | URL, options?: RequestInit): Promise<Response> {
               // Attach the in-person session bearer when one is active. Used
               // by inPersonSessionProcedure endpoints; other public endpoints
               // ignore the header.
               const session = readInPersonSession()
               if (session) {
                  const headers = (options?.headers ?? {}) as Record<string, string>
                  headers['authorization'] = `Bearer ${session.bearerToken}`
                  options = { ...options, headers }
               }
               return trpcFetcher({
                  silent,
                  fetchParams: [input, options],
                  cors: true
               })
            }
         })
      ]
   })
}

export const apiPublicClient = createPublicClient()
export const apiPublicClientSilent = createPublicClient(true)
